<template src="./html/Edit.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import Multiselect from 'vue-multiselect'
	import Jobs from '../../jobs/Jobs.vue'
	import Timer from '../../timers/views/Index.vue'

	export default {
		props: ['user', 'isAuth', 'data', 'item'],
		components: {
			'multiselect': Multiselect,
			'jobs': Jobs,
			'timer': Timer,
		},
		data () {
			return {
				usersUnAvailable: [],

				busy: {
					schedule: false,
					place: false,
				},

				schedule: {
					start: null,
					end: null,
				},
			}
		},
		mounted () {
			this.checkAvailableDate()
			this.deleteSameSchedule()

			this.unFormatData()
		},
		methods: {
			usersChange() {
				this.deleteSameSchedule()
				this.checkAvailableDate()
				this.checkAvailableUsers()
			},
			estimatedStartChange() {
				this.checkAvailableUsers()
				this.checkAvailableDate()
			},
			estimatedEndChange() {
				this.checkAvailableUsers()
				this.checkAvailableDate()
			},
			deleteSameSchedule() {
				var that = this
				if(this.item) {
					if(this.item.users) {
						if(this.item.users.length) {
							this.item.users.forEach(function(user) {
								if(user.schedules) {
									if(user.schedules.length) {
										user.schedules.forEach(function(schedule) {
											if(schedule.id == that.item.id) {
												let index = user.schedules.indexOf(schedule)
												user.schedules.splice(index, 1)
											}
										})
									}
								}
							})
						}
					}
				}
			},
			openModalScheduleJobs() {
				this.$emit('openModalScheduleJobs', this.item)
			},
			checkAvailableUsers() {
				this.usersUnAvailable = []

				var start_date = this.schedule.start
				var end_date = this.schedule.end
				
				var users = this.item.users

				if(users) {
					for (var i = 0; i < users.length; i++) {
						var user = users[i]
						var unavailable = user.profile.unavailable

						if(unavailable.length) {
							for (var k = 0; k < unavailable.length; k++) {
								var element = unavailable[k]

								var start = moment(element.start_date)
								var end = moment(element.end_date)

								var start_date = moment(start_date)
								var end_date = moment(end_date)

								var betweenStart = start.isBetween(start_date, end_date)
								var isSameStart = start.isSame(start_date)
								var betweenEnd = end.isBetween(start_date, end_date)
								var isSameEnd = end.isSame(end_date)


								if(betweenStart || betweenEnd || isSameStart || isSameEnd) {
									user['unavailable'] = {
										start_date: start,
										end_date: end,
										type: element.type,
									}
									var index = this.usersUnAvailable.indexOf(user)
									if(index < 0) {
										if (typeof user.display_alert == 'undefined') {
											this.usersUnAvailable.push(user)
										}
									}
								} else {
									var betweenStart = start_date.isBetween(start, end)
									var betweenEnd = end_date.isBetween(start, end)

									if(betweenStart || betweenEnd) {
										user['unavailable'] = {
											start_date: start,
											end_date: end,
											type: element.type,
										}
										var index = this.usersUnAvailable.indexOf(user)
										if(index < 0) {
											if (typeof user.display_alert == 'undefined') {
												this.usersUnAvailable.push(user)
											}
										}
									}
								}
							}
						}
					}

					if(this.usersUnAvailable.length) {

						if(this.usersUnAvailable.length) {
							if(this.usersUnAvailable[0]) {
								if (typeof this.usersUnAvailable[0].display_alert == 'undefined') {

									var start_date = moment(this.usersUnAvailable[0].unavailable.start_date).format('DD/MM/YY - H:mm')
									var end_date = moment(this.usersUnAvailable[0].unavailable.end_date).format('DD/MM/YY - H:mm')

									if(this.usersUnAvailable[0].profile.avatar) {
										var imageUrl = this.usersUnAvailable[0].profile.avatar
										var html = '<img class="swal2-image img-circle" src="'+imageUrl+'"width="150" height="150" style="display: block;">'
									} else {
										var html = '<p><i class="fa fa-user-circle-o fa-5x" aria-hidden="true"></i>'
									}

									html += '</p>No disponible</p>' +
									'</p>' + this.usersUnAvailable[0].unavailable.type + ': ' + start_date + ' | ' + end_date + '</p>'

									swal({
										title: this.usersUnAvailable[0].email,
										html: html,
										showCloseButton: true,
										showCancelButton: true,
										confirmButtonText: 'Ignorar',
										confirmButtonColor: "#ff7676",
										cancelButtonColor: '#3085d6',
										cancelButtonText: 'OK',
									})
									.then((result) => {
										this.usersUnAvailable[0].display_alert = false
										this.showAvailableUsers(0)
									})
									.catch((result) => {
										this.showAvailableUsers(0)
									})
								} else {
									this.showAvailableUsers(0)
								}
							}
						}
					} else {
						return null;
					}
				}
			},
			checkAvailableDate() {
				this.busy.schedule = false
				this.busy.place = false
				var that = this

				var start_date = this.schedule.start

				if(start_date) {
					var estimated_start = moment(start_date)

					if(estimated_start.isValid()) {
						var end_date = this.schedule.end

						if(end_date) {
							var estimated_end = moment(end_date)

							if(estimated_end.isValid()) {

								this.item.users.forEach(function(user) {
									that.$set(user, 'busy', false)
									if(user.schedules) {
										if(user.schedules.length) {
											user.schedules.forEach(function(schedule) {
												that.$set(schedule, 'busy', false)

												if(schedule.place) {
													that.$set(schedule.place, 'busy', false)
												}

												var schedule_start =  moment(schedule.estimated_start)
												var schedule_end =  moment(schedule.estimated_end)

												var betweenStart = estimated_start.isBetween(schedule_start, schedule_end)
												var isSameStart = estimated_start.isSame(schedule_start)
												var betweenEnd = estimated_end.isBetween(schedule_start, schedule_end)
												//var isSameEnd = estimated_end.isSame(schedule_end)

												if(betweenStart || betweenEnd || isSameStart) {
													schedule.busy = true
													that.busy.schedule = true
													user.busy = true

													if(schedule.place) {
														if(that.item.place) {
															if(schedule.place.id == that.item.place.id) {
																schedule.place.busy = true
																that.busy.place = true
															}
														}
													}
												} else {
													var betweenStart = schedule_start.isBetween(estimated_start, estimated_end)
													var betweenEnd = schedule_end.isBetween(estimated_start, estimated_end)

													if(betweenStart || betweenEnd) {
														schedule.busy = true
														that.busy.schedule = true
														user.busy = true

														if(schedule.place) {
															if(that.item.place) {
																if(schedule.place.id == that.item.place.id) {
																	schedule.place.busy = true
																	that.busy.place = true
																}
															}
														}
													}
												}
											})
										}
									}
								})
							}
						}
					}
				}
			},
			showAvailableUsers(key) {
				var i = key + 1
				if(this.usersUnAvailable.length) {
					if(this.usersUnAvailable[i]) {
						if(typeof this.usersUnAvailable[i].display_alert == 'undefined') {

							var start_date = moment(this.usersUnAvailable[i].unavailable.start_date).format('DD/MM/YY - H:mm')
							var end_date = moment(this.usersUnAvailable[i].unavailable.end_date).format('DD/MM/YY - H:mm')

							if(this.usersUnAvailable[i].profile.avatar) {
								var imageUrl = this.usersUnAvailable[i].profile.avatar
								var html = '<img class="swal2-image img-circle" src="'+imageUrl+'"width="150" height="150" style="display: block;">'
							} else {
								var html = '<p><i class="fa fa-user-circle-o fa-5x" aria-hidden="true"></i>'
							}

							html += '</p>No disponible</p>' +
							'</p>' + this.usersUnAvailable[i].unavailable.type + ': ' + start_date + ' | ' + end_date + '</p>'

							swal({
								title: this.usersUnAvailable[i].email,
								html: html,
								showCloseButton: true,
								showCancelButton: true,
								confirmButtonText: 'Ignorar',
								confirmButtonColor: "#ff7676",
								cancelButtonColor: '#3085d6',
								cancelButtonText: 'OK',
							})
							.then((result) => {
								this.usersUnAvailable[i].display_alert = false
								this.showAvailableUsers(i)
							})
							.catch((result) => {
								this.showAvailableUsers(i)
							})
						} else {
							this.showAvailableUsers(i)
						}
					}
				}
			},
			deleteSchedule() {
				var that = this

				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.item_can_not_be_retrieved"),
					type: "warning",
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showCancelButton: true,
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.delete('admin/projects/schedules/' + that.item.id)
							.then(response => {
								that.$emit('reload')
								swal({
									title: response.body.title,
									text: response.body.text,
									type: response.body.type
								});
							}).catch(function(response) {
								console.log(response)
							})
						})
					}
				}]).catch(swal.noop)
			},
			updateSchedule(item) {
				this.formatData()
				if(!this.busy.place) {
					var button = this.$refs.btnupdate
					var l = Ladda.create(button);
					l.start();
					this.$http.put('admin/projects/schedules/' + item.id, item)
					.then(response => {
						l.stop()
						swal(response.body.title, response.body.text, response.body.type)
					}).catch(function(response) {
						console.log(response)
						l.stop()
					})
				}
			},
			canDone() {
				return moment().isAfter(this.item.estimated_start)
			},
			done() {
				var that = this
				if(this.item.done) {
					var title = that.$t("messages.the_schedule_will_be_marked_as_not_done")
				} else {
					var title = that.$t("messages.the_schedule_will_be_marked_as_done")
				}
				swal.queue([{
					title: that.$t("messages.attention"),
					text: title,
					type: "warning",
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showCancelButton: true,
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.get('admin/projects/schedules/' + that.item.id + '/done')
							.then(response => {
								that.$emit('reload')
								swal({
									title: response.body.title,
									text: response.body.text,
									type: response.body.type
								});
							}).catch(function(response) {
								console.log(response)
								that.$emit('reload')
							})
						})
					}
				}]).catch(swal.noop)
			},
			reload() {
				this.$emit('reload')
			},
			dateUnavailable (unavailable) {
				if(unavailable.length) {
					for (var i = 0; i < unavailable.length; i++) {
						var element = unavailable[i]
						var start = moment(element.start_date)
						var end = moment(element.end_date)
						if(moment().isBetween(start, end)) {
							return start.format('DD/MM/YYYY - H:mm') + ' | ' + end.format('DD/MM/YYYY - H:mm')
						}
					}
				}
			},
			typeUnavailable(unavailable) {
				if(unavailable.length) {
					for (var i = 0; i < unavailable.length; i++) {
						var element = unavailable[i]
						var start = moment(element.start_date)
						var end = moment(element.end_date)
						if(moment().isBetween(start, end)) {
							return element.type
						}
					}
				}
			},
			openPopoverDate(id) {
				var popover = $('#popover-'+id)
				popover.popover('toggle')
			},
			formatData() {
				if(this.schedule.start) {
					var estimated_start = moment(this.schedule.start)
					this.item.estimated_start = estimated_start.format('YYYY-MM-DD H:mm:ss')
				}
				if(this.schedule.end) {
					var estimated_end = moment(this.schedule.end)
					this.item.estimated_end = estimated_end.format('YYYY-MM-DD H:mm:ss')
				}
			},
			unFormatData() {
				if(this.item.estimated_start) {
					var start = moment(this.item.estimated_start)
					this.schedule.start = start.toISOString()
				}
				if(this.item.estimated_end) {
					var estimated_end = moment(this.item.estimated_end)
					this.schedule.end = estimated_end.toISOString()
				}
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/projects/schedules/views/Edit.vue